var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBantrBoxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 940.5 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-3 {\n        fill: #000;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: gold;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.9,110.8h37.3c6.1,0,10.6,1.4,13.4,4.2,2.9,2.8,4.3,7,4.3,12.6s-.8,6.8-2.4,9.1c-1.6,2.3-3.6,4-6,4.9,5,1.4,8.5,4.7,10.2,10.1.6,1.9.9,4.2.9,6.7,0,6.1-1.4,10.6-4.3,13.4-2.9,2.9-7.3,4.3-13.4,4.3h-40.1v-65.2h0ZM329.1,129.5c0-3.7-1.9-5.6-5.6-5.6h-15.8v13.1h15.8c3.7,0,5.6-1.9,5.6-5.6v-1.9h0ZM331.9,155.6c0-3.7-1.9-5.6-5.6-5.6h-18.6v13.1h18.6c3.7,0,5.6-1.9,5.6-5.6v-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.7,176.1h-18.2l24.7-65.2h18.6l24.7,65.2h-18.2l-4.2-11.6h-23.3l-4.2,11.6h0ZM377.1,152.3h14.9l-7.5-21.9-7.5,21.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M480.1,176.1h-17.7l-22.4-39.1v39.1h-16.8v-65.2h17.7l22.4,39.1v-39.1h16.8v65.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M523,176.1h-16.8v-52.2h-19.6v-13.1h55.9v13.1h-19.6v52.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M549.1,110.8h39.1c6.5,0,11.3,1.5,14.2,4.4s4.4,7.7,4.4,14.2v8.4c0,5.2-.9,9.2-2.6,12-1.7,2.9-4.4,4.8-8.2,5.7l11.7,20.5h-18.2l-10.7-19.6h-13v19.6h-16.8v-65.2h0ZM590.1,129.5c0-3.7-1.9-5.6-5.6-5.6h-18.6v19.6h18.6c3.7,0,5.6-1.9,5.6-5.6v-8.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M644.1,110.8h37.3c6.1,0,10.6,1.4,13.4,4.2,2.9,2.8,4.3,7,4.3,12.6s-.8,6.8-2.4,9.1c-1.6,2.3-3.6,4-6,4.9,5,1.4,8.5,4.7,10.2,10.1.6,1.9.9,4.2.9,6.7,0,6.1-1.4,10.6-4.3,13.4s-7.3,4.3-13.4,4.3h-40.1v-65.2h0ZM682.3,129.5c0-3.7-1.9-5.6-5.6-5.6h-15.8v13.1h15.8c3.7,0,5.6-1.9,5.6-5.6v-1.9h0ZM685.1,155.6c0-3.7-1.9-5.6-5.6-5.6h-18.6v13.1h18.6c3.7,0,5.6-1.9,5.6-5.6v-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M769,158.4c0,6.5-1.5,11.3-4.4,14.2-3,2.9-7.7,4.4-14.2,4.4h-23.3c-6.5,0-11.3-1.5-14.2-4.4s-4.4-7.7-4.4-14.2v-29.8c0-6.5,1.5-11.3,4.4-14.2s7.7-4.4,14.2-4.4h23.3c6.5,0,11.3,1.5,14.2,4.4s4.4,7.7,4.4,14.2v29.8h0ZM752.2,128.5c0-3.7-1.9-5.6-5.6-5.6h-15.8c-3.7,0-5.6,1.9-5.6,5.6v29.8c0,3.7,1.9,5.6,5.6,5.6h15.8c3.7,0,5.6-1.9,5.6-5.6v-29.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M814.2,110.8h18.6l-21,32.6,21.4,32.6h-18.6l-13-20.5-13,20.5h-18.6l21.4-32.6-21-32.6h18.5l12.7,20.5,12.6-20.5h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.1,77h-54.4c-13,0-23.5,10.5-23.5,23.5v14.7c0,11.5,8.3,21.1,19.2,23.1v21.1l28.1-20.8h30.5c13,0,23.5-10.5,23.5-23.5v-14.7c0-13-10.5-23.5-23.5-23.5h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 129.8,
    cy: 107.1,
    r: 7.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 152.9,
    cy: 107.1,
    r: 7.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 176,
    cy: 107.1,
    r: 7.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.9,126.7h54.4c13,0,23.5,10.5,23.5,23.5v14.7c0,11.5-8.3,21.1-19.2,23.1v21.1l-28.1-20.8h-30.5c-13,0-23.5-10.5-23.5-23.5v-14.7c0-13,10.5-23.5,23.5-23.5h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 230.3,
    cy: 156.8,
    r: 7.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.1,
    cy: 156.8,
    r: 7.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184,
    cy: 156.8,
    r: 7.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBantrBoxLogo);
export default __webpack_public_path__ + "static/media/BantrBoxLogo.ab5be05eda8ef4cc063c1f99a9e4d5bb.svg";
export { ForwardRef as ReactComponent };